import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ViewType } from "../common/enums/view-type.enum";

@Injectable({
  providedIn: "root",
})
export class ViewTypeService {
  private selectedViewTypeSubject = new BehaviorSubject<ViewType>(
    ViewType.NONE
  );
  selectedViewType$ = this.selectedViewTypeSubject.asObservable();

  setSelectedViewType(viewType: ViewType): void {
    this.selectedViewTypeSubject.next(viewType);
  }

  getSelectedViewType(): ViewType {
    return this.selectedViewTypeSubject.value;
  }
}
